import { array, boolean, literal, nullable, number, struct, union } from 'io-ts/Decoder';

import { Id as FloorLevel } from '../../../ai/floor-level/Id';

const JobSetupLevelRequirement = struct({
	floorLevel: FloorLevel,
	floorDepth: nullable(number),
	studSpacing: nullable(number),
});

// Job-wide Top Plate requirement. `null` remains decodable for legacy drafts;
// current clients normalize it to the double-plate default.
export const JobSetupUpdated = struct({
	type: literal('job-setup-updated'),
	roundingIncrement: number,
	levelRequirements: array(JobSetupLevelRequirement),
	topPlateRequirement: nullable(union(literal('single'), literal('double'))),
	// Job-wide opt-in: Brain Engine must not snap frame thicknesses to standard
	// values when true. [ROME-7967]
	nonStandardThickness: boolean,
});
